import { lazyNamed } from 'src/utils/lazyNamed';

export default {
  Helmet: lazyNamed(() => import('./Helmet'), 'Helmet'),
  AiChat: lazyNamed(() => import('./pages/Chat'), 'AiChat'),
  AiSettingsAgents: lazyNamed(() => import('./pages/Settings/AgentsPage'), 'AgentsPage'),
  AiSettingsAgentForm: lazyNamed(() => import('./pages/Settings/AgentForm'), 'AgentFormPage'),
  AiSettingsMcpServers: lazyNamed(() => import('./pages/Settings/McpServersPage'), 'McpServersPage'),
  AiSettingsMcpServerForm: lazyNamed(() => import('./pages/Settings/McpServerForm'), 'McpServerFormPage'),
  AiSettingsBrandKits: lazyNamed(() => import('./pages/Settings/BrandKitsPage'), 'BrandKitsPage'),
  AiSettingsBrandKitForm: lazyNamed(() => import('./pages/Settings/BrandKitForm'), 'BrandKitFormPage'),
};
